import { render } from "./AdminAddShopPanel.vue?vue&type=template&id=1910b663&scoped=true"
import script from "./AdminAddShopPanel.vue?vue&type=script&lang=js"
export * from "./AdminAddShopPanel.vue?vue&type=script&lang=js"

import "./AdminAddShopPanel.vue?vue&type=style&index=0&id=1910b663&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1910b663"]])

export default __exports__